import { Button, Stack, Tooltip } from "@mui/material";

import { useDisclosure } from "hooks";

import { PublicShipmentLatestETA } from "../PublicShipmentLatestETA";
import { PublicShipmentStateDisplay } from "../PublicShipmentStateDisplay";
import { PublicShipmentStatusHistoryTable } from "../PublicShipmentStatusHistoryTable";

interface Props {
  shipment: PublicShipment;
}

export function PublicShipmentStatusSection(props: Props) {
  const { shipment } = props;
  const {
    isOpen: historyOpen,
    onOpen: onOpenHistory,
    onClose: onCloseHistory,
  } = useDisclosure(false);

  return (
    <Stack mb="1.5rem">
      <Stack direction="column" spacing={1}>
        <PublicShipmentStateDisplay shipment={shipment} />
        <PublicShipmentLatestETA etas={shipment.etas} />
      </Stack>
      <Stack sx={{ pt: "1rem" }} direction="row" justifyContent="right">
        <Tooltip
          title={
            historyOpen
              ? "Hide shipment status history"
              : "Show shipment status history"
          }
        >
          <Button
            variant="text"
            onClick={historyOpen ? onCloseHistory : onOpenHistory}
          >
            {historyOpen ? "Hide history" : "Show history"}
          </Button>
        </Tooltip>
      </Stack>
      {historyOpen && <PublicShipmentStatusHistoryTable shipment={shipment} />}
    </Stack>
  );
}
